/*
 * Copyright (c) 2024 Amazon.com, Inc. All Rights Reserved.
 */
/**
 * @author pdoriand Sep 04, 2024
 */
export enum AntiSignatureType {
    ANTI_HUMAN = "anti-human",
    ANTI_ROBOT = "anti-robot",
    BAD_FORMAT = "Bad Format"
}

export const AntiSignatureFeatures = [
    "acceptencoding",
    "acceptlanguage",
    "referer",
    "customerid",
    "customeridcookiename",
    "encryptedcustomercookie",
    "headerorder",
    "ip",
    "url",
    "sslciphersuites",
    "sslellipticcurves",
    "useragent",
    "isp",
    "asn",
    "missingfields"
]

export interface AntiSignatureEntry {
    aggregatedBy: Map<string, string>,
    region: string,
    signatureType: AntiSignatureType,
    description: string,
    models: Set<string>,
    ttl: number,
    labels: Set<string>,
    creationTime: number,
    author?: string,
    lastModifiedBy?: string
}

export const convertTtlToDaysRemaining = (antisignature: AntiSignatureEntry) => {
    if (antisignature.ttl === 0) {
        return "No Expiration";
    }
    const expirationDate = antisignature.creationTime + antisignature.ttl * 24 * 60 * 60 * 1000;
    return Math.ceil((expirationDate - Date.now()) / (24 * 60 * 60 * 1000));
}